import React, { useState, useEffect } from 'react';
import '../styles/ThemeToggle.css';

const ThemeToggle = () => {
  const [isExpertTheme, setIsExpertTheme] = useState(false);

  // Load saved theme preference on mount
  useEffect(() => {
    const savedTheme = localStorage.getItem('chessKingdomTheme');
    if (savedTheme === 'expert') {
      setIsExpertTheme(true);
      document.body.classList.add('expert-theme');
    }
  }, []);

  const toggleTheme = () => {
    const newTheme = !isExpertTheme;
    setIsExpertTheme(newTheme);
    
    if (newTheme) {
      document.body.classList.add('expert-theme');
      localStorage.setItem('chessKingdomTheme', 'expert');
    } else {
      document.body.classList.remove('expert-theme');
      localStorage.setItem('chessKingdomTheme', 'modern');
    }
  };

  return (
    <button 
      className={`theme-toggle-btn ${isExpertTheme ? 'expert-active' : ''}`}
      onClick={toggleTheme}
      title={isExpertTheme ? 'Switch to Modern Theme' : 'Switch to Expert Theme'}
    >
      <span className="theme-icon">
        {isExpertTheme ? '🎯' : '🪵'}
      </span>
      <span className="theme-label">
        {isExpertTheme ? 'Expert' : 'Classic'}
      </span>
    </button>
  );
};

export default ThemeToggle;
